// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "small[data-v-28d1a3e6]{font-size:12px;min-width:115px}", ""]);
// Exports
module.exports = exports;
